<template>
  <div class="testv__video__player__player__wrapper">
    <video
      id="vid1"
      class="video-js"
      :poster="video.pic"
      autoplay
      muted
      playsinline>
      <source :src="this.video.url">
    </video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
  name: 'TestvVideoPlayer',

  props: {
    video: Object
  },

  data () {
    return {
      player: null
    }
  },

  mounted () {
    this.player = videojs('vid1', {
      autoplay: true,
      controls: true,
      muted: true,
      preload: 'auto',
      controlBar: {
        // volumePanel: false
      }
    });
    this.player.on('play', () => {
      this.$emit('play')
    })
    this.player.on('fullscreenchange', () => {
      this.$emit('fullscreenchange')
    })
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.video-js {
  width: 100%;
  height: 100%;
  >>> .vjs-tech {
    position: relative;
  }
  >>> .vjs-progress-holder {
    height: 8px;
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
  }
  >>> .vjs-control-bar {
    background: rgba(0, 0, 0, 0.5);
  }
  >>> .vjs-load-progress,
  >>> .vjs-load-progress div {
    background: rgba(255, 255, 255, 0.05);
  }
  >>> .vjs-slider {
    rgba(255, 255, 255, 0.05);
  }
  >>> .vjs-slider-bar {
    background: rgba(#FFC000, 0.1);
    &:not(.vjs-volume-bar)::before {
      content: '';
      display: inline-block;
      background: var(--yellow-testv);
      width: 2px;
      height: 100%;
      font-size: 0;

    }

  }
}
</style>
